<template>
  <div
    class="header-search"
    :class="{ 'hidden-mobile': hiddenMobile }"
  >
    <dropdown-menu
      id="search-menu"
      hide-chevron
      align-right
      full-width
    >
      <template v-slot:button>
        <div class="icon-and-input">
          <magnify-icon />

          <input
            ref="input"
            v-model="new_search"
            type="search"
            :class="{ 'blue-text': searchType && searchType !== 'search' }"
            :placeholder="placeholder"
            @keydown.enter.prevent="searchListings"
            @search="clear"
          >
        </div>

        <button
          type="button"
          class="btn btn-transparent"
          @click="hiddenMobile = !hiddenMobile; searchListings()"
        >
          <magnify-icon v-if="hiddenMobile" />
          <close-icon
            v-else
            class="search-close"
          />
        </button>
      </template>
      <template v-if="searchType === 'tag'">
        <li
          v-for="(tag, index) in matchedTags"
          :key="`tag${index}`"
          class="li-tag clickable"
          @click="new_search = `#${tag.name}`; searchListings();"
        >
          #{{ tag.name }}
        </li>
        <li
          class="li-tag"
        >
          {{ elipses }}
        </li>
      </template>
      <li
        v-if="!searchType"
        class="li-tag"
      >
        #SearchTag
      </li>
      <li
        v-if="!searchType"
        class="li-tag"
      >
        @Search User
      </li>
      <li>
        <router-link
          :to="{ name: 'add_search' }"
          style="color: var(--blue)"
        >
          Listings Advanced Search
        </router-link>
      </li>
    </dropdown-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DropdownMenu from '@/components/DropdownMenu.vue';

export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      new_search: this.$route.query.search || '',
      keywords: '',
      hiddenMobile: true,
      no_posts: false,
      elipses: '...',
    };
  },
  computed: {
    ...mapState([
      'categories',
      'userGroups',
    ]),
    search() {
      return this.$route.query.search || '';
    },
    tags() {
      return this.$store.state.tags.results;
    },
    matchedTags() {
      if (this.new_search === '#') {
        return [];
      }
      return this.tags.filter(t => t.name.includes(this.new_search.substring(1))).slice(0, 5);
    },
    placeholder() {
      this.setNoPosts(false);

      const route = this.$route.name;
      let placeholder = route;
      if (route === 'home') {
        placeholder = 'Search all posts';
      } else if (route === 'profile') {
        placeholder = 'Search your posts';
      } else if (route === 'favorites') {
        placeholder = 'Search your favorites';
      } else if (route === 'sold_listings') {
        placeholder = 'Search sold listings';
      } else if (route === 'looking') {
        placeholder = 'Search looking to buy';
      } else if (route === 'user_listings') {
        placeholder = 'Search your listings';
      } else if (route === 'all_listings') {
        placeholder = 'Search listings';
      } else if (route === 'profile') {
        placeholder = 'Search your posts';
      } else if (route === 'listing_category') {
        const category = this.categories.results.find(
          c => c.slug === this.$route.params.categorySlug,
        );
        placeholder = `Search ${category.name}`;
      } else if (route === 'group_detail') {
        const group = this.userGroups.find(
          g => g.id === Number(this.$route.params.id),
        );
        if (group) {
          placeholder = `Search ${group.name}`;
        } else {
          placeholder = 'Group not found';
        }
      } else {
        placeholder = 'Search listings';
        this.setNoPosts(true);
      }

      return placeholder;
    },
    searchType() {
      if (this.new_search) {
        let type = 'search';
        if (this.new_search.startsWith('#')) {
          type = 'tag';
        } else if (this.new_search.startsWith('@')) {
          type = 'user';
        }
        return type;
      }
      return null;
    },
  },
  watch: {
    hiddenMobile(newValue) {
      if (!newValue) {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },
    search(newValue) {
      this.new_search = newValue;
    },
  },
  created() {
    setInterval(() => {
      this.updateElipses();
    }, 500);
  },
  methods: {
    updateElipses() {
      if (this.elipses.length === 3) this.elipses = '.';
      else this.elipses += '.';
    },
    setNoPosts(bool) {
      this.no_posts = bool;
    },
    searchListings() {
      if (this.searchType === 'tag') {
        this.$router.push({ name: 'tagged', params: { name: this.new_search.substring(1) } });
      } else if (this.searchType === 'user') {
        this.$router.push({ name: 'users_search', params: { search: this.new_search.substring(1) } });
      } else {
        if (this.no_posts) {
          this.$router.push('/listings');
        }

        this.$router.replace({
          query: {
            search: this.new_search,
            page: 1,
            listing: '',
          },
        });
      }
    },
    clear() {
      this.new_search = '';
      this.searchListings();
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-search {
    position: absolute;
    top: 0;
    left: 0;
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: 0 15px;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 1;

    /deep/ button {
      width: 100%;
    }

    &.hidden-mobile {
      position: static;
      display: block;
      padding: 0;
      text-align: right;
      background-color: transparent;

      .icon-and-input {
        display: none;
      }
    }
    .search-close {
      position: absolute;
      top: 15px;
      right: 6px;
    }
  }

  /deep/ #search-menu {
    margin-top: -10px;
  }

  .icon-and-input {
    position: relative;
    margin-top: 10px;

    .magnify-icon {
      position: absolute;
      top: 0.1rem;
      left: 0.4rem;
    }

    input {
      padding-left: 1.75rem;
    }
  }

  .magnify-icon {
    font-size: 1.5rem;
    color: var(--blue-dark);
    margin-right: 10px;
  }

  @media (min-width: 1024px) {
    .header-search {
      position: static;
      display: block;
      padding: 0;
      width: 360px;
      background-color: transparent;

      .icon-and-input {
        display: block !important;
      }
    }

    /deep/ #search-menu {
      margin-top: 0px;
    }

    button {
      display: none;
    }
  }
</style>

<style lang="scss" scoped>
.li-tag {
  font-size: 0.8rem;
  padding: 6px;
  text-align: left;
}

.blue-text {
  color: var(--blue);
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  color: var(--blue);
}
</style>
